"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * There are 3 different ways to represent numbers with thousands and decimal separators.
 *
 *  10 000,12 - internationally recommended
 *  10.000,12 - most common in non-english speaking countries
 *  10,000.12 - most common in english speaking countries
 *
 *  Our databases don't need any of that though. They need:
 *
 *  10000.12 - no thousand separators and a decimal point for the decimal separator, not a comma.
 *
 *  This function standardises all inputs to look like our required format for db number entry.
 *
 * Reference: https://en.wikipedia.org/wiki/Decimal_separator
 */
exports.default = (number, fixedDecimalPlaces) => {
    const standardised = Number(String(number).replace(/[ ,]/g, '.').replace(/\.(?!\d+$)/gim, ''));
    return fixedDecimalPlaces ? Number(standardised.toFixed(fixedDecimalPlaces)) : standardised;
};
